import React from 'react';
import { StepLayout, StepHelperText, ActionButton } from "../../BusinessOnboardingWidget.utils";
import { CompleteKYCIcon } from "../../BusinessOnboardingWidget.icons";
import styles from "./CompleteKYC.module.scss";
function CompleteKYCAction(props) {
  return /*#__PURE__*/React.createElement(StepLayout, {
    id: "kyc",
    title: "Complete KYB verification to fully automate your billing",
    subtitle: "Anchor is legally required to verify your business. Once that\u2019s done, you can accept payments.",
    actions: /*#__PURE__*/React.createElement("div", {
      className: styles.actionsWrapper
    }, /*#__PURE__*/React.createElement(ActionButton, {
      "data-testid": "onboarding-widget-complete-kyc",
      onClick: props.startKyc
    }, "Complete KYB"), /*#__PURE__*/React.createElement(StepHelperText, null, "* Verification process takes several minutes up to three business days.")),
    icon: /*#__PURE__*/React.createElement(CompleteKYCIcon, null)
  });
}
function KYCUnderReview() {
  return /*#__PURE__*/React.createElement(StepLayout, {
    id: "kyc",
    title: "You've successfully submitted your KYB information",
    subtitle: "You will be notified if additional information is needed.",
    actions: /*#__PURE__*/React.createElement("div", {
      "data-testid": "onboarding-widget-under-review",
      className: styles.actionsWrapper
    }, /*#__PURE__*/React.createElement(StepHelperText, null, "* Verification process takes several minutes up to three business days.")),
    icon: /*#__PURE__*/React.createElement(CompleteKYCIcon, null)
  });
}
function KYCCompleted() {
  return /*#__PURE__*/React.createElement(StepLayout, {
    id: "kyc",
    title: "You've successfully completed the KYB process",
    subtitle: 'Payments can now be transferred to your account',
    actions: null,
    icon: /*#__PURE__*/React.createElement(CompleteKYCIcon, null)
  });
}
export default function CompleteKYC(props) {
  const {
    isComplete,
    extraProps
  } = props;
  const {
    startKyc,
    isUnderReview
  } = extraProps;
  if (isComplete) {
    return /*#__PURE__*/React.createElement(KYCCompleted, null);
  } else if (isUnderReview) {
    return /*#__PURE__*/React.createElement(KYCUnderReview, null);
  } else {
    return /*#__PURE__*/React.createElement(CompleteKYCAction, {
      startKyc: startKyc
    });
  }
}